export function setDatosRegio(state, payload){
    state.datosphp = payload.data
    state.error= false 
}
export function datosregioError (state, payload){
    state.error = true
    state.errorMessage = payload
}
export function flushDatosRegio(state){
    state.datosphp = []
    state.error= false
    state.totalRow= 0
}